import { linkToClassAssignmentsPage } from "../links";

export function linkToAssignmentsOverviewPage(classId?: string) {
  return `${linkToClassAssignmentsPage(classId)}/overview`;
}
